export enum recipientGroupTypes {
  GROUPS = 'groups',
  EMPLOYEES = 'employees',
  GUARDIANS = 'guardians',
  CHILDREN = 'children',
  COMMON_INBOXES = 'commonInboxes',
}
